// Get job mini interview questions **************************
// pathname: /v1/job/{jobSlug}/unanswered-questions
// ******************************************************
import { useSwrApi } from '@hooks/useSwrApi';

/** Props */
type JobMiniInterviewQuestionsProps = {
  jobSlug: string;
  locale: Locale;
  shouldFetch?: boolean;
};

/**
 * @description Get job interview questions.
 * - `jobSlug`: *string* - The job slug.
 * - `locale`: *Locale* - The current app locale.
 * - `shouldFetch`: *boolean* - Should fetch data. Only explicit 'false' disables fetching.
 */
export const useSwrJobMiniInterviewQuestions = (props: JobMiniInterviewQuestionsProps) => {
  const {
    jobSlug,
    locale = 'ro',
    shouldFetch = true,
  } = props;

  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'Question'>[]>({
    url: `/v1/job/${jobSlug}/unanswered-questions`,
    locale,
    shouldFetch,
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
